<template>
  <button
    v-if="clickable"
    class="list-row-container"
    @click="$emit('row-clicked')"
  >
    <slot />
  </button>
  <div
    v-else
    class="list-row-container"
  >
    <slot />
  </div>
</template>

<script>
// Feature branch for List View revisions
export default {
  props: {
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['row-clicked'],
};
</script>

<style lang="scss" scoped>
.list-row-container {
  .row-group {
    align-items: center;
    display: flex;
    flex: 1;

    @include breakpoint(small) {
      align-items: flex-start;
      flex-direction: column-reverse;
    }
  }

  :deep(img.arrow) {
    margin: auto 0 auto rem-calc(24);
    width: rem-calc(14);
  }

  :deep(.center-container) {
    align-items: center;
    display: flex;
    flex: 1;

    @include breakpoint(small) {
      align-items: flex-start;
      flex-direction: column-reverse;
    }
  }

  &.list-heading {
    color: $grey-3;
    font-size: rem-calc(12);

    .name-heading {
      flex: 1;
      margin-left: rem-calc(16);
    }
  }
}
</style>
